import {EventStoredObject, OddsObject} from "../../../@types/response";

export default function Odds({
                                 odds,
                             }: { odds: OddsObject[], event: EventStoredObject }) {

    return (
            <div className='flex justify-between'>
                {odds.map((odd: OddsObject, idx) => {
                    return <div
                            key={idx}
                            data-id={`book-odds-${odd.signId}`}
                            data-value={odd.odd.toFixed(2)}
                            className={`p-1 rounded-md mx-1 text-center w-1/${odds.length} `}
                    >
                        <div
                        >{odd.odd.toFixed(2)}</div>
                    </div>
                })}
            </div>
    )
}
